var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.027l5.533 3.346c1.014.614 2.254-.293 1.987-1.44l-1.467-6.293 4.894-4.24c.893-.773.413-2.24-.76-2.333l-6.44-.547-2.52-5.947c-.454-1.08-2-1.08-2.454 0l-2.52 5.934-6.44.546c-1.173.094-1.653 1.56-.76 2.334l4.894 4.24L4.48 20.92c-.267 1.147.973 2.053 1.987 1.44L12 19.027z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.471397d629677b78d4e16d076d601de9.svg";
export { ForwardRef as ReactComponent };